<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.details }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.customerFile.title.$invalid && $v.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Naziv</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="customerFile.title"
                      />
                      <form-error
                        :model="$v.customerFile.title"
                        :dirty="$v.$dirty"
                        label="Naziv"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Dokument</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        readonly
                        placeholder="Dokument"
                        v-model="customerFile.fileName"
                      />
                    </div>
                  </div>
                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Komitent</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        readonly
                        placeholder="Komitent"
                        v-model="customerFile.companyTitle"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Zaštićen?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="customerFile.protected"
                          id="is-protected"
                        />
                        <label for="is-protected"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            exact
            :to="{ name: 'CustomerFiles' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header"><strong>{{ translations.deleteCustomerFile }}</strong></h5>
        <div slot="body">
          <span v-html="modalText">
          </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="deleteCustomerFile" data-bs-dismiss="modal">
                {{ translations.yes }}
              </button>
              <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';

export default {
  name: 'EditCustomerFile',
  mixins: [translations],
  validations: {
    customerFile: {
      ...validations,
    },
  },
  components: { FormError, Modal },
  computed: {
    modalText() {
      return this.translations.areYouSureCustomerFile.replace('{customerFile}', `<strong>${this.customerFile.title}</strong>`);
    },
    customerFile() {
      return this.$store.getters.getCustomerFile;
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  mounted() {
    this.$store.dispatch('getCustomerFileAsAdmin', this.$route.params.id);
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      const formData = new FormData();

      formData.append('title', this.customerFile.title);
      formData.append('protected', this.customerFile.protected);
      api
        .updateCustomerFile(this.customerFile.id, formData)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'CustomerFiles' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    deleteCustomerFile() {
      api
        .deleteCustomerFiles([this.customerFile.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'CustomerFiles' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
  },
};
</script>
